import { ReactNode } from 'react';

interface IConditionalWrapperProps {
  condition: boolean;
  wrapper: (children: ReactNode) => ReactNode;
  children: ReactNode;
}

const ConditionalWrapper = ({ condition, wrapper, children }: IConditionalWrapperProps) => (
  // eslint-disable-next-line react/jsx-no-useless-fragment
  <>{condition ? wrapper(children) : children}</>
);

export default ConditionalWrapper;
